import DataSplitIcon from "../../../../../../assets/svg/data-split-icon";
import ProgrammingArrowsIcon from "../../../../../../assets/svg/programming-arrows-icon";
import SendIcon2 from "../../../../../../assets/svg/send-icon-2";
import UserCircleAddIcon from "../../../../../../assets/svg/user-circle-add-icon";
import WatchIcon from "../../../../../../assets/svg/watch-icon";
import TasksIcon from "../../../../../../assets/svg/tasks-icon";
import ViewingsIcon from "../../../../../../assets/svg/viewings-icon";
import PeopleIcon from "../../../../../../assets/svg/people-icon";
import { IconProps } from "../../../../../../utils/global-types/global-types";
import { NODE_TYPE } from "./types";

export enum NODE_CATEGORIES {
  TRIGGER = "trigger",
  ACTION = "action",
  RULE = "rule",
}

export enum TRIGGER_NODE_TYPES {
  TRIGGER_EVENT_HANDLER = "triggerEventHandler",
}

export enum ACTION_NODE_TYPES {
  OUTBOUND_COMMUNICATION = "outboundCommunication",
  END_JOURNEY = "endJourney",
  USER_UPDATE = "userUpdate",
  CREATE_TASK = "createTask",
  ASSIGN_AGENT = "assignAgent",
  CREATE_VIEWING = "createViewing",
}

export enum RULE_NODE_TYPES {
  DELAY = "delay",
  FILTER = "filter",
  CONDITIONAL_SPLIT_BRANCH = "conditionalSplitBranch",
  CONDITIONAL_SPLIT = "conditionalSplit",
  WORKING_HOURS = "workingHours",
  WORKING_HOURS_BRANCH = "workingHoursBranch",
  REDIRECT_TO_STEP = "redirectToStep",
}

export const NODE_LABELS = {
  [TRIGGER_NODE_TYPES.TRIGGER_EVENT_HANDLER]: "Entry Trigger",
  [ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION]: "Reach Out",
  [ACTION_NODE_TYPES.USER_UPDATE]: "Data Update",
  [ACTION_NODE_TYPES.CREATE_TASK]: "Create a Task",
  [ACTION_NODE_TYPES.ASSIGN_AGENT]: "Assign an Agent",
  [ACTION_NODE_TYPES.CREATE_VIEWING]: "Create a Viewing",
  [RULE_NODE_TYPES.REDIRECT_TO_STEP]: "Redirect to Step",
  [RULE_NODE_TYPES.DELAY]: "Time Delay",
  [RULE_NODE_TYPES.FILTER]: "Filter",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT]: "Action Split",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT_BRANCH]: "Action Split Branch",
  [RULE_NODE_TYPES.WORKING_HOURS]: "Time Split",
  [RULE_NODE_TYPES.WORKING_HOURS_BRANCH]: "Time Split Branch",
};

export interface NodeButtonConfig {
  Icon: (props: IconProps) => React.JSX.Element;
  label: string;
  nodeType: NODE_TYPE;
  buttonClassName: string;
  iconClassName?: string;
  hoverNodeClass: string;
  selectedNodeClass: string;
  /** When false, hidden from the leaf-edge "Add action" top row (shown in sidebar + More section only) */
  primary?: boolean;
}

export const NODES_BUTTONS: NodeButtonConfig[] = [
  {
    Icon: SendIcon2,
    label: "Reach Out",
    nodeType: ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION,
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    hoverNodeClass:
      "hover:text-node-tags-reachout-text hover:dark:text-node-tags-reachout-text-dk hover:bg-node-tags-reachout-bg hover:dark:bg-node-tags-reachout-bg-dk",
    selectedNodeClass:
      "text-node-tags-reachout-text dark:text-node-tags-reachout-text-dk bg-node-tags-reachout-bg dark:bg-node-tags-reachout-bg-dk",
  },
  {
    Icon: WatchIcon,
    label: "Time Delay",
    nodeType: RULE_NODE_TYPES.DELAY,
    iconClassName: "w-4! h-4! shrink-0",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    hoverNodeClass:
      "hover:text-node-tags-time-delay-text hover:dark:text-node-tags-time-delay-text-dk hover:bg-node-tags-time-delay-bg hover:dark:bg-node-tags-time-delay-bg-dk",
    selectedNodeClass:
      "text-node-tags-time-delay-text dark:text-node-tags-time-delay-text-dk bg-node-tags-time-delay-bg dark:bg-node-tags-time-delay-bg-dk",
  },
  // {
  //   Icon: LoginIcon,
  //   label: "End Journey",
  //   nodeType: ACTION_NODE_TYPES.END_JOURNEY,
  //   buttonClassName:
  //     "text-journey-node-default dark:text-journey-node-default-dk",
  //   hoverNodeClass: "hover:text-journey-end-node-selected hover:dark:text-journey-end-node-selected-dk",
  //   selectedNodeClass:
  //     "text-journey-end-node-selected dark:text-journey-end-node-selected-dk bg-tags-cyan-bg dark:bg-tags-cyan-bg-dk",
  // },
  // {
  //   Icon: ArrowSplitIcon,
  //   label: "Decision Split",
  //   nodeType: RULE_NODE_TYPES.FILTER,
  //   hoverNodeClass: "hover:text-tags-red-border hover:dark:text-tags-red-border-dk",
  //   buttonClassName:
  //     "text-journey-node-default dark:text-journey-node-default-dk",
  //   selectedNodeClass:
  //     "text-tags-red-border dark:text-tags-red-border-dk bg-tags-red-bg dark:bg-tags-red-bg-dk",
  // },
  {
    Icon: DataSplitIcon,
    label: "Action Split",
    iconClassName: "w-3.5! h-3.5! shrink-0",
    nodeType: RULE_NODE_TYPES.CONDITIONAL_SPLIT,
    hoverNodeClass:
      "hover:text-node-tags-action-split-text hover:dark:text-node-tags-action-split-text-dk hover:bg-node-tags-action-split-bg hover:dark:bg-node-tags-action-split-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-action-split-text! dark:text-node-tags-action-split-text-dk! bg-node-tags-action-split-bg dark:bg-node-tags-action-split-bg-dk",
  },
  // {
  //   Icon: TimerIcon2,
  //   label: "Time Split",
  //   nodeType: RULE_NODE_TYPES.WORKING_HOURS,
  //   hoverNodeClass:
  //     "hover:text-tags-violet-text hover:dark:text-tags-violet-text-dk",
  //   buttonClassName:
  //     "text-journey-node-default dark:text-journey-node-default-dk",
  //   selectedNodeClass:
  //     "text-tags-violet-text! dark:text-tags-violet-text-dk! bg-tags-violet-bg dark:bg-tags-violet-bg-dk",
  // },
  {
    Icon: ProgrammingArrowsIcon,
    label: "Redirect To Step",
    nodeType: RULE_NODE_TYPES.REDIRECT_TO_STEP,
    iconClassName: "w-3.5! h-3.5! shrink-0",
    hoverNodeClass:
      "hover:text-node-tags-redirect-text hover:dark:text-node-tags-redirect-text-dk hover:bg-node-tags-redirect-bg hover:dark:bg-node-tags-redirect-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-redirect-text dark:text-node-tags-redirect-text-dk bg-node-tags-redirect-bg dark:bg-node-tags-redirect-bg-dk",
  },
  {
    Icon: UserCircleAddIcon,
    label: "Data Update",
    nodeType: ACTION_NODE_TYPES.USER_UPDATE,
    iconClassName: "w-3.5! h-3.5! shrink-0",
    hoverNodeClass:
      "hover:text-node-tags-user-update-text hover:dark:text-node-tags-user-update-text-dk hover:bg-node-tags-user-update-bg hover:dark:bg-node-tags-user-update-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk",
  },
  {
    Icon: TasksIcon,
    label: "Create Task",
    nodeType: ACTION_NODE_TYPES.CREATE_TASK,
    iconClassName: "w-3.5! h-3.5! shrink-0",
    hoverNodeClass:
      "hover:text-node-tags-user-update-text hover:dark:text-node-tags-user-update-text-dk hover:bg-node-tags-user-update-bg hover:dark:bg-node-tags-user-update-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk",
    primary: false,
  },
  {
    Icon: ViewingsIcon,
    label: "Schedule Viewing",
    nodeType: ACTION_NODE_TYPES.CREATE_VIEWING,
    iconClassName: "w-3.5! h-3.5! shrink-0",
    hoverNodeClass:
      "hover:text-node-tags-user-update-text hover:dark:text-node-tags-user-update-text-dk hover:bg-node-tags-user-update-bg hover:dark:bg-node-tags-user-update-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk",
    primary: false,
  },
  {
    Icon: PeopleIcon,
    label: "Assign Agent",
    nodeType: ACTION_NODE_TYPES.ASSIGN_AGENT,
    iconClassName: "w-3.5! h-3.5! shrink-0",
    hoverNodeClass:
      "hover:text-node-tags-user-update-text hover:dark:text-node-tags-user-update-text-dk hover:bg-node-tags-user-update-bg hover:dark:bg-node-tags-user-update-bg-dk",
    buttonClassName:
      "text-journey-node-default dark:text-journey-node-default-dk",
    selectedNodeClass:
      "text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk",
    primary: false,
  },
];

/**
 * Returns Tailwind classes for the colored "node tag" pill shown above each
 * node (e.g. `Reach Out`, `Time Delay`, `Redirect to Step`). Centralised here
 * so wizards / lists / illustrations can render the same pill colors as the
 * canvas without duplicating the per-type Tailwind strings.
 */
export const getNodeTagPillClassName = (nodeType: NODE_TYPE): string => {
  switch (nodeType) {
    case ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION:
      return "border border-node-tags-reachout dark:border-node-tags-reachout-dk text-node-tags-reachout-text dark:text-node-tags-reachout-text-dk bg-node-tags-reachout-bg dark:bg-node-tags-reachout-bg-dk";
    case RULE_NODE_TYPES.REDIRECT_TO_STEP:
      return "border border-node-tags-redirect dark:border-node-tags-redirect-dk text-node-tags-redirect-text dark:text-node-tags-redirect-text-dk bg-node-tags-redirect-bg dark:bg-node-tags-redirect-bg-dk";
    case ACTION_NODE_TYPES.USER_UPDATE:
      return "border border-journey-update-node-selected dark:border-journey-update-node-selected-dk text-journey-update-node-selected dark:text-journey-update-node-selected-dk bg-journey-update-node-bg dark:bg-journey-update-node-bg-dk";
    case RULE_NODE_TYPES.DELAY:
      return "border border-node-tags-time-delay dark:border-node-tags-time-delay-dk text-node-tags-time-delay-text dark:text-node-tags-time-delay-text-dk bg-node-tags-time-delay-bg dark:bg-node-tags-time-delay-bg-dk";
    case RULE_NODE_TYPES.CONDITIONAL_SPLIT:
    case RULE_NODE_TYPES.CONDITIONAL_SPLIT_BRANCH:
      return "border border-node-tags-action-split dark:border-node-tags-action-split-dk text-node-tags-action-split-text dark:text-node-tags-action-split-text-dk bg-node-tags-action-split-bg dark:bg-node-tags-action-split-bg-dk";
    case TRIGGER_NODE_TYPES.TRIGGER_EVENT_HANDLER:
      return "border border-tags-blue-border dark:border-tags-blue-border-dk text-tags-blue-border dark:text-tags-blue-border-dk bg-tags-blue-bg dark:bg-tags-blue-bg-dk";
    default:
      return "border border-tags-gray-text dark:border-tags-gray-text-dk text-tags-gray-text dark:text-tags-gray-text-dk bg-tags-gray-bg dark:bg-tags-gray-bg-dk";
  }
};

//Node Type to Category Map builder
const buildCategoryMap = (): Record<NODE_TYPE, NODE_CATEGORIES> => {
  const map = {} as Record<NODE_TYPE, NODE_CATEGORIES>;
  for (const t of Object.values(TRIGGER_NODE_TYPES))
    map[t] = NODE_CATEGORIES.TRIGGER;
  for (const t of Object.values(ACTION_NODE_TYPES))
    map[t] = NODE_CATEGORIES.ACTION;
  for (const t of Object.values(RULE_NODE_TYPES)) map[t] = NODE_CATEGORIES.RULE;
  return map;
};

export const NODE_TYPE_TO_CATEGORY = buildCategoryMap();

export const FIELD_AFFECTING_NODE_TYPES: ReadonlySet<NODE_TYPE> = new Set([
  ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION,
  TRIGGER_NODE_TYPES.TRIGGER_EVENT_HANDLER,
]);

export const NODE_TYPE_PILL_CLASS: Record<string, string> = {
  [TRIGGER_NODE_TYPES.TRIGGER_EVENT_HANDLER]:
    "bg-tags-blue-bg dark:bg-tags-blue-bg-dk text-tags-blue-border dark:text-tags-blue-border-dk",
  [ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION]:
    "bg-node-tags-reachout-bg dark:bg-node-tags-reachout-bg-dk text-node-tags-reachout-text dark:text-node-tags-reachout-text-dk",
  [RULE_NODE_TYPES.DELAY]:
    "bg-node-tags-time-delay-bg dark:bg-node-tags-time-delay-bg-dk text-node-tags-time-delay-text dark:text-node-tags-time-delay-text-dk",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT]:
    "bg-node-tags-action-split-bg dark:bg-node-tags-action-split-bg-dk text-node-tags-action-split-text dark:text-node-tags-action-split-text-dk",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT_BRANCH]:
    "bg-node-tags-action-split-bg dark:bg-node-tags-action-split-bg-dk text-node-tags-action-split-text dark:text-node-tags-action-split-text-dk",
  [ACTION_NODE_TYPES.USER_UPDATE]:
    "bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk",
  [ACTION_NODE_TYPES.CREATE_TASK]:
    "bg-node-tags-action-split-bg dark:bg-node-tags-action-split-bg-dk text-node-tags-action-split-text dark:text-node-tags-action-split-text-dk",
  [ACTION_NODE_TYPES.ASSIGN_AGENT]:
    "bg-node-tags-user-update-bg dark:bg-node-tags-user-update-bg-dk text-node-tags-user-update-text dark:text-node-tags-user-update-text-dk",
  [ACTION_NODE_TYPES.CREATE_VIEWING]: "bg-[#E0EEC6] text-[#4a6b2a]",
  [RULE_NODE_TYPES.REDIRECT_TO_STEP]:
    "bg-node-tags-redirect-bg dark:bg-node-tags-redirect-bg-dk text-node-tags-redirect-text dark:text-node-tags-redirect-text-dk",
  [RULE_NODE_TYPES.FILTER]:
    "bg-tags-red-bg dark:bg-tags-red-bg-dk text-tags-red-border dark:text-tags-red-border-dk",
  [RULE_NODE_TYPES.WORKING_HOURS]:
    "bg-node-tags-time-delay-bg dark:bg-node-tags-time-delay-bg-dk text-node-tags-time-delay-text dark:text-node-tags-time-delay-text-dk",
  [RULE_NODE_TYPES.WORKING_HOURS_BRANCH]:
    "bg-node-tags-time-delay-bg dark:bg-node-tags-time-delay-bg-dk text-node-tags-time-delay-text dark:text-node-tags-time-delay-text-dk",
};

export const DEFAULT_PILL_CLASS =
  "bg-tags-gray-bg dark:bg-tags-gray-bg-dk text-tags-gray-text dark:text-tags-gray-text-dk";

/**
 * Outline for an outlined pill, keyed the same way as `NODE_TYPE_PILL_CLASS` — apply alongside it.
 * Each node type's base token is already the mid-tone between its `-bg` and `-text`, which is
 * exactly the relationship the design uses for the stroke, so the base token IS the border colour.
 *
 * Kept separate rather than folded into `NODE_TYPE_PILL_CLASS` so the canvas node labels, which the
 * design leaves un-outlined, are unaffected.
 */
export const NODE_TYPE_PILL_BORDER_CLASS: Record<string, string> = {
  [TRIGGER_NODE_TYPES.TRIGGER_EVENT_HANDLER]:
    "border-node-tags-entry-trigger dark:border-node-tags-entry-trigger-dk",
  [ACTION_NODE_TYPES.OUTBOUND_COMMUNICATION]:
    "border-node-tags-reachout dark:border-node-tags-reachout-dk",
  [RULE_NODE_TYPES.DELAY]:
    "border-node-tags-time-delay dark:border-node-tags-time-delay-dk",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT]:
    "border-node-tags-action-split dark:border-node-tags-action-split-dk",
  [RULE_NODE_TYPES.CONDITIONAL_SPLIT_BRANCH]:
    "border-node-tags-action-split dark:border-node-tags-action-split-dk",
  [ACTION_NODE_TYPES.USER_UPDATE]:
    "border-node-tags-user-update dark:border-node-tags-user-update-dk",
  [ACTION_NODE_TYPES.CREATE_TASK]:
    "border-node-tags-action-split dark:border-node-tags-action-split-dk",
  [ACTION_NODE_TYPES.ASSIGN_AGENT]:
    "border-node-tags-user-update dark:border-node-tags-user-update-dk",
  // No base token of its own (its pill is the one raw-hex entry above); the user-update green is
  // the nearest token to that pale green fill.
  [ACTION_NODE_TYPES.CREATE_VIEWING]:
    "border-node-tags-user-update dark:border-node-tags-user-update-dk",
  [RULE_NODE_TYPES.REDIRECT_TO_STEP]:
    "border-node-tags-redirect dark:border-node-tags-redirect-dk",
  [RULE_NODE_TYPES.FILTER]:
    "border-tags-red-border dark:border-tags-red-border-dk",
  [RULE_NODE_TYPES.WORKING_HOURS]:
    "border-node-tags-time-delay dark:border-node-tags-time-delay-dk",
  [RULE_NODE_TYPES.WORKING_HOURS_BRANCH]:
    "border-node-tags-time-delay dark:border-node-tags-time-delay-dk",
};

export const DEFAULT_PILL_BORDER_CLASS =
  "border-border-gray dark:border-border-gray-dk";
